import type { HTMLProps } from "react";
import { forwardRef, memo } from "react";

import { Button } from "@jti/core-components/components/Button";
import { useSelector } from "@jti/store/reduxHooks";
import { TextInput, useTranslations } from "@jti/ui";
import { useDeviceBreakpoint } from "@jti/ui/hooks/useDeviceBreakpoint";

import styles from "./PromoCodeControls.module.scss";

export const PromoCodeControls = memo(
  forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement> & { isError?: boolean; errorText?: string; value?: string }>(
    (props, ref) => {
      const { __ } = useTranslations();
      const { breakpoint } = useDeviceBreakpoint();
      const isDesktop = breakpoint === "desktop";

      const couponsPending = useSelector((state) => state.cart.couponsPending);

      const {
        promoCode: { isLimitReached },
      } = useSelector((state) => state.cart);

      return (
        <div className={styles.voucherControls}>
          <TextInput
            {...props}
            id="promo-code-input"
            ref={ref}
            type="text"
            value={props.value ?? ""}
            placeholder={__("cart.promo_code.field_placeholder")}
            maxLength={50}
            data-testid="promoCodeInput"
            readOnly={couponsPending || isLimitReached}
          />
          <Button
            className={styles.applyButton}
            pending={couponsPending}
            disabled={!props.value || couponsPending || isLimitReached}
            variant="secondary"
            type="submit"
            fullWidth={!isDesktop}
            size={isDesktop ? "md" : undefined}
            data-testid="applyButton"
          >
            {__("cart.promo_code.apply_button")}
          </Button>
        </div>
      );
    }
  )
);
